(function () {
    'use strict';

    angular
        .module('externalPartyEditModule', [
            'oddModule',
            'oddCampaignModule',
            'oddSurveyModule',
            'services.historyCtxt'
        ]);
})();
